import { WARNING_SEVERITY_TO_ALERT_VARIANT } from '../../types';
import { Alert } from '../Alert';
import type { PMSWarningColumnValue } from '../BlotterTable/columns/pmsWarning';
import { HStack, VStack } from '../Core';
import { Text } from '../Text';

/** Warnings for Portfolio Management System rows */
export function PMSRowWarnings({ warningData }: { warningData: PMSWarningColumnValue }) {
  const alertVariant = WARNING_SEVERITY_TO_ALERT_VARIANT[warningData.severity];

  return (
    <VStack gap="spacing2" w="100%" p="spacing4" maxWidth="70vw">
      <Alert
        w="100%"
        variant={alertVariant}
        dismissable={false}
        justifyContent="space-between"
        alignItems="center"
        p="spacing8"
      >
        <VStack alignItems="flex-start" gap="spacing4" w="100%">
          {warningData.warnings.toSorted().map((warningItem, idx) => (
            <HStack key={idx + '::' + warningItem} gap="spacing4" justifyContent="space-between" w="100%">
              <Text size="fontSizeMd" color="gray.100">
                {warningItem}
              </Text>
            </HStack>
          ))}
        </VStack>
      </Alert>
    </VStack>
  );
}
